(function () {
  function initReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const selectors = [
      '.ssw-hero-copy',
      '.collection-hero__inner',
      '.card-wrapper',
      '.featured-collection .title-wrapper-with-link',
      '.template-product .product__info-wrapper',
      '.template-product .product__media-wrapper',
    ];

    const elements = document.querySelectorAll(selectors.join(','));
    if (!elements.length) return;

    elements.forEach((el) => el.classList.add('ssw-luxury-reveal'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -48px 0px', threshold: 0.12 }
    );

    elements.forEach((el) => observer.observe(el));
  }

  function initHeroShopScroll() {
    document.querySelectorAll('.ssw-hero-scroll-shop').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target =
          document.getElementById('ssw-home-shop') ||
          link.closest('.shopify-section')?.nextElementSibling;

        if (!target) return;

        event.preventDefault();

        const header = document.querySelector('.section-header');
        const headerHeight = header ? header.getBoundingClientRect().height : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
      });
    });
  }

  function initMenuDrawerClose() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('.ssw-menu-drawer__close-top');
      if (!button) return;

      const summary = document.querySelector('header-drawer summary.header__icon--menu');
      if (!summary) return;
      summary.click();
    });
  }

  function initMenuDrawerScrollLock() {
    if (window.matchMedia('(min-width: 990px)').matches) return;

    const details = document.querySelector('#Details-menu-drawer-container');
    const panel = document.getElementById('menu-drawer');
    if (!details || !panel) return;

    function syncMenuState() {
      const isOpening = details.hasAttribute('open') && details.classList.contains('menu-opening');
      const isOpen = details.hasAttribute('open');

      document.documentElement.classList.toggle('ssw-menu-drawer-open', isOpening);

      if (isOpen) {
        if (panel.parentElement !== document.body) {
          document.body.appendChild(panel);
        }
      } else if (panel.parentElement === document.body) {
        details.appendChild(panel);
      }
    }

    const observer = new MutationObserver(syncMenuState);
    observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    syncMenuState();
  }

  function initMenuDrawerSubmenuBack() {
    document.addEventListener(
      'click',
      (event) => {
        const backButton = event.target.closest('.menu-drawer__close-button');
        if (!backButton || backButton.classList.contains('ssw-menu-drawer__close-top')) return;

        const detailsElement = backButton.closest('details');
        if (!detailsElement || detailsElement.id === 'Details-menu-drawer-container') return;

        const drawer = document.querySelector('header-drawer');
        if (!drawer || typeof drawer.closeSubmenu !== 'function') return;

        event.preventDefault();
        event.stopPropagation();
        drawer.closeSubmenu(detailsElement);
      },
      true
    );
  }

  function initHeroAmbientVideo() {
    document.querySelectorAll('.ssw-hero-video-main[data-ssw-ambient-video]').forEach((video) => {
      if (video.dataset.sswAmbientInit === 'true') return;
      video.dataset.sswAmbientInit = 'true';

      const tryPlay = () => {
        const playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => {});
        }
      };

      video.addEventListener('canplay', tryPlay, { once: true });
      video.addEventListener('loadeddata', tryPlay, { once: true });

      if (video.readyState >= 2) {
        tryPlay();
      } else {
        window.setTimeout(tryPlay, 500);
      }
    });
  }

  function initProductGalleryNoLightbox() {
    if (!document.body.classList.contains('template-product')) return;

    document.addEventListener(
      'click',
      (event) => {
        const toggle = event.target.closest('.product__media-wrapper .product__media-toggle');
        if (!toggle) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      },
      true
    );
  }

  function init() {
    initMenuDrawerClose();
    initMenuDrawerScrollLock();
    initMenuDrawerSubmenuBack();
    initReveal();
    initHeroShopScroll();
    initHeroAmbientVideo();
    initProductGalleryNoLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
